// import request from './request';
import search from './CAT4MRO/search';
import infGeneral from './Stages/infGeneral';
import inventory from './Stages/inventory';
import description from './Stages/description';
import equipmentAPL from './Stages/equipment-group-APL';
import logs from './Stages/logs';
import analystView from './Stages/analystView';

export default {
  createNewMaterial: {
    cat4mro: {
      ...search,
    },
    infGeneral: {
      ...infGeneral,
    },
    inventory: {
      ...inventory,
    },
    description: {
      ...description,
    },
    equipmentAPL: {
      ...equipmentAPL,
    },
    tabs: {
      infGeneral: 'General Information',
      inventory: 'Inventory',
      description: 'Description',
      equipmentAPL: 'APL Equipment',
      attachments: 'Attachments',
      similarMaterials: 'Similar Materials',
      suggestedProvider: 'Suggested Suppliers',
    },
    matReqStatusCondition: "This material request is in the status condition of ",
    searchProviders: "Search Providers",
    send: "Send",
    approve: "Approve",
    reject: "Reject",
    cancel: "Cancel",
    next: "Next",
    previous: "Previous",
    openInTab: "Open in a new tab",
    tittleCreationSuccess: "SUCCESS",
    creationSuccess: "The material was created successfully",
    editionSuccess: "The material was edited successfully",
    tittleCreationError: "Error",
    creationError: "An error occurred while creating the material",
    errorTittle: "Error",
    approveError: "An error occurred while approving the material",
    rejectError: "An error occurred while rejecting the material",
    uploadError: "An error has occurred while uploading the file",
    editionError: "An error has occurred while editing the material",
    sendError: "An error has occurred while sending the material",
    setAttachmentsError: "Error while trying to add attachments to the material request",
    uploadFile: "Upload file",
    uploadFileError: "An error has occurred while uploading the file",
    uploadFileSuccess: "File uploaded successfully",
    uploadFilesExcedded: "The size of the attached files exceeds the limit (10)",
    deleteFileError: "An error has occurred while trying to delete the file",
    deleteFileSuccess: "File deleted successfully",
    alertTittleRemoveFile: "Delete file",
    alertMessageRemoveFile: "Are you sure you want to delete the file ",
    alertConfirmRemoveFile: "Delete",
    alertCancelRemoveFile: "Cancel",
    messageDeletedFile: "File deleted",
    cancelationError: "An error has occurred while canceling the material",
    cancelationSuccess: "Material request canceled successfully",
    closeFormConfirm: "¿Do you wish to close the form?",
    closeFormConfirmTitle: "Warning",
    closeFormConfirmYes: "Yes",
    closeFormConfirmNo: "No",
    logs,
    attachments: {
      maximunSize: "The maximum size per attached files is 5MB",
      error: "An error has occurred while trying to upload the file",
      maximunSizeError: "Maximum size per file exceeds the limit (5MB)",
    },
    analystView: {
      ...analystView,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/index.js